import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { BotonesInicio } from "./tirabotones";
const uruzNaranja = require("app/img/uruzNaranja.png");

class Titulo extends React.PureComponent<{ titulo: string }> {
    render() {
        return (
            <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontSize: "14px", fontWeight: "bold", marginLeft: "12px", marginBottom: "7px" }} >
                    {this.props.titulo}
                </span>
                <div style={{ height: 1, flex: "1 0 auto", background: "rgba(255,255,255,0.8)" }} />
            </div>
        )
    }
}

class Item extends React.PureComponent<{ texto: string, onClick?: () => void }> {
    render() {
        return (
            <div>
                <a href="#" target="_top" onClick={this.props.onClick} style={{ marginLeft: "13px", fontSize: "11px", color: "white" }} >
                    {this.props.texto}
                </a>
            </div>
        )
    }
}

export interface FooterProps {
    selected: BotonesInicio;
    onChange: (x: BotonesInicio) => void;
}

export class Footer extends React.PureComponent<FooterProps> {
    render() {
        return (
            <div style={{
                background: "rgba(245,102,0, 1)",
                width: "942px",
                height: "272px",
                display: "flex",
                flexDirection: "row",
                paddingTop: "22px",
                color: "white",
                fontFamily: "'Montserrat', sans-serif"
            }}>
                {/* <div style={{ flex: "0 1 auto", marginLeft: "25px" }}>
                    <img src={uruzNaranja} />
                </div> */}

                <div style={{ flex: "0 1 auto", marginLeft: "20px", width: "130px" }}>
                    <Titulo titulo="Nosotros" />
                    {[
                        "Quiénes somos",
                        "Trabaja con nosotros"
                    ].map((x, i) => <Item key={i} texto={x} onClick={() => this.props.onChange("nosotros")} />)}
                    <Item texto="Aviso de privacidad" onClick={() => this.props.onChange("aviso")} />
                </div>

                <div style={{ flex: "0 1 auto", marginLeft: "25px", width: "150px" }}>
                    <Titulo titulo="Servicios" />
                    {[
                        "Paquetería",
                        "Mensajería",
                        "Entregas:",
                        "  Ocurre",
                        "  A domicilio",
                        "Tipos de pago:",
                        "  Pago en origen",
                        "  Flete por cobrar",
                        "Recolección a domicilio",
                        "Seguro",
                        "Servicios en línea:",
                        "  Rastreo de envíos",
                        "  Cotizador",
                        "  Información de envíos",
                        "  Uruz en tu empresa"
                    ].map((x, i) => <Item key={i} texto={x} onClick={() => this.props.onChange("servicios")} />)}
                </div>

                <div style={{ flex: "0 1 auto", marginLeft: "20px", width: "130px" }}>
                    <Titulo titulo="Cobertura" />
                    {[
                        "Mapa de cobertura",
                    ].map((x, i) => <Item key={i} texto={x} onClick={() => this.props.onChange("cobertura")} />)}
                </div>

                <div style={{ flex: "0 1 auto", marginLeft: "20px", width: "130px" }}>
                    <Titulo titulo="Sucursales" />
                    {[
                        "Sucursales",
                        "Direcciones",
                        "Coorporativo"
                    ].map((x, i) => <Item key={i} texto={x} onClick={() => this.props.onChange("sucursales")} />)}
                </div>

                <div style={{ flex: "0 1 auto", marginLeft: "20px", width: "130px" }}>
                    <Titulo titulo="Contacto" />

                    {/* <div>
                        <span style={{marginLeft: "11px", fontSize: "11px" }}>
                            Línea de atención
                        </span>
                        <br />
                        <span style={{marginLeft: "11px", fontSize: "14px", fontWeight: "bold" }}>
                            01800 812 9065
                        </span>
                    </div> */}
                    <Item texto="contacto@uruz.mx" onClick={() => this.props.onChange("contacto")} />
                    <br />
                    {[
                        "Lunes a Viernes:",
                        "8:00 a 19:00 hrs.",
                        "Sábados:",
                        "8:00 a 14:00 hrs."
                    ].map((x, i) => <Item key={i} texto={x} onClick={() => this.props.onChange("contacto")} />)}

                </div>

                <div style={{ flex: "0 1 auto", marginLeft: "20px", width: "130px" }}>
                    <Titulo titulo="Redes sociales" />

                    <div style={{ marginLeft: "13px", fontSize: 40 }}>
                        <a style={{ fontSize: 40, color: "white" }} href="https://www.facebook.com/URUZ-Servicios-Inteligentes-de-Log%C3%ADstica-SA-de-CV-778764088998675/" target="_blank" > <i style={{ padding: "5px" }} className={fa("facebook-official")}>  </i> </a>
                        <a style={{ fontSize: 40, color: "white" }} href="https://www.instagram.com/uruzmx/?hl=en" target="_blank" ><i style={{ padding: "5px" }} className={fa("instagram")} > </i></a>
                    </div>

                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/diseño/items/footer.tsx